import styled from "styled-components";
import colors from "../../constants/color";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: rgba(17, 24, 39, 0.28);
`;

export const Card = styled.div`
  width: min(520px, 100%);
  max-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 28px 32px;
  border-radius: 14px;
  background-color: #ffffff;
  box-shadow: 0 18px 48px rgba(17, 24, 39, 0.22);
`;

export const IconWrapper = styled.div`
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 22px;
  background-color: rgba(244, 54, 54, 0.11);
`;

export const IconCircle = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #f43636;
  background-color: rgba(244, 54, 54, 0.16);
`;

export const Messages = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 26px;
  overflow-y: auto;
`;

export const Text = styled.p`
  margin: 0;
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.35;
  color: #333333;

  strong {
    font-weight: 800;
  }
`;

export const Button = styled.button`
  align-self: flex-end;
  min-width: 112px;
  height: 44px;
  padding: 0 20px;
  border: none;
  border-radius: 8px;
  color: #ffffff;
  background-color: ${colors.primary};
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 10px 20px rgba(45, 91, 255, 0.18);

  &:hover {
    filter: brightness(0.96);
  }

  &:focus-visible {
    outline: 3px solid rgba(45, 91, 255, 0.32);
    outline-offset: 3px;
  }
`;
